/***
 * @author rick
 * @description 打印的复用逻辑
 * @description 用于/charge/pay.vue 和 /registry/detail.vue
 */
import { mapGetters } from 'vuex';
import { getLodop } from '@/common/LodopFuncs';

export default {
  computed: {
    ...mapGetters(['dict', 'user']),
  },
  methods: {
    // 打印设置的数据
    setReceiptData(reg, payment, isForPay) {
      const { fmtFloat, dictText } = this.$utils;
      function formatFloat(val) {
        return fmtFloat(val, 2);
      }
      const {
        patientName, appCardNo, cardNo, opType, doctorName, regType, date, periodType, periodStart, periodEnd, opNo, registrarId, appointmentDate, deptName, seqNo
      } = reg;
      const { feeAmount, feeCash, feeFund, payWay } = payment;
      // 支付方式：接口返回的payWay会出现null
      const paymentText = payWay ? dictText(payWay, "PayWay")  : '现金';
      const cash = payWay === 'enterprise' ? feeAmount : feeCash

      return {
        hospitalName: this.user.tenantName, // 医院名称
        cardNo: appCardNo || cardNo, // 患者卡号
        patientName, // 患者名称
        regType: (doctorName || "") + dictText(regType, "RegType"), // 号类
        date, // 就诊日期
        periodType: periodType + periodStart + "～" + periodEnd, // 候诊时间
        seqNo: seqNo + "号", // 序号
        deptName, // 科室
        opType, // 患者费别
        amount: formatFloat(feeAmount) + "元", // 支付、医事服务费
        insurance: formatFloat(0) + "元", // 医保内，新接口的数据里已经没有insurance字段，暂时显示为0。
        opNo, // 门诊号
        registerId: (registrarId + "").padStart(4, 0), // 挂号员id
        takeTime: appointmentDate, // 挂号时间
        paymentInfo: "基金支付：" + formatFloat(feeFund) + "元\n" + paymentText + "：" + formatFloat(cash) + "元",
      };
    },
    printReceipt(reg, payment) {
      const template = this.dict.PrintTemplate.find((t) => t.code === "RegReceipt");
      if (!template) {
        this.$message.error("未找到凭证模板信息！");
        return;
      }
      let LODOP = getLodop();
      eval(template.content);
      LODOP.SET_PRINT_PAGESIZE(1, 800, 1980, ""); // 设定纸张大小
      Object.entries(this.setReceiptData(reg, payment)).forEach(([item, value]) => {
        LODOP.SET_PRINT_STYLEA(item, "CONTENT", value);
      });
      // 指定打印机
      if (localStorage.getItem("printerConfig")) {
        const printerConfig = JSON.parse(localStorage.getItem("printerConfig"));
        if (printerConfig && printerConfig.registeredPrintVoucher) {
          LODOP.SET_PRINTER_INDEX(printerConfig.registeredPrintVoucher);
        }
      }
      LODOP.PRINT();
    },

    // 用于registry/detail.vue
    printReceiptFn(reg, payment) {
      let receiptData = this.setReceiptData(reg, payment, false);
      this.$utils.printRpt('RegReceipt', receiptData).then(r => {
        // this.$message({ type: 'success', message: '打印成功！' });
      }).catch(e => {
        this.$message({ type: 'error', message: e });
      });
    },
  },
};
